import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { Catalogue } from "@singularsystems/neo-react-services";
import GLAccountType from "../../../Models/Catalogue/General/GLAccountType";

export default class GLAccountTypeCatalogueEntry extends CatalogueEntry<GLAccountType> {

    constructor() {
        super("GL Account Types", GLAccountType);
    }

    public get editRole() {
        return CatalogueRoles.GLAccountTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.glAccountTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveGLAccountTypes;
    }

    public renderRow(item: GLAccountType, meta: Model.TransformMetaType<GLAccountType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.glAccountTypeCode} />
                <NeoGrid.Column bind={meta.glAccountTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}